import TransformationsPage from './TransformationsPage'

export default TransformationsPage
